import { render, staticRenderFns } from "./ConventionPresentation.vue?vue&type=template&id=1a557649&scoped=true"
import script from "./ConventionPresentation.vue?vue&type=script&lang=js"
export * from "./ConventionPresentation.vue?vue&type=script&lang=js"
import style0 from "./ConventionPresentation.vue?vue&type=style&index=0&id=1a557649&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a557649",
  null
  
)

export default component.exports